import { createSlice, PayloadAction } from '@reduxjs/toolkit';

const initialState = false;

const barraProgresoMobileSlice = createSlice({
	name: 'barraProgresoMobile',
	initialState,
	reducers: {
		displayBarraProgreso: (state, action: PayloadAction<boolean>) => {
			return action.payload;
		}
	}
});

export const { displayBarraProgreso } = barraProgresoMobileSlice.actions;

export default barraProgresoMobileSlice.reducer;
